import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getUserProducts } from "../../redux/userShopSlice";
import Loader from '../Loader';
import ShopProductCard from "./ShopProductCard";

const ShopProductsPanel = () => {
    const { isLoading, error, data } = useSelector(state => state.userShop);
    const dispatch = useDispatch();
    useEffect(() => {
            dispatch(getUserProducts());
    }, [])
    return (
        <div className="CARD-CONTAINER grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4">
            {
                error && !isLoading && (error.message || 'Errore sconosciuto nel ricercare i prodotti')
            }
            {
                isLoading && <Loader isMobileCenter />
            }
            {
                !isLoading &&
                data && data.length > 0 && data.map((element, index) => {
                    return <ShopProductCard key={index} productId={element._id} coverImage={element.coverImageUrl?.resizedUrl || null} title={element.title} price={element.price} />
                })
            }
        </div>
    )
}

export default ShopProductsPanel;